// extracted by mini-css-extract-plugin
export default {"cell":"TableRowCellButton-cell-_ezEn TableRowCell-cell-giPrj Link-link-RInnp"};